(function () {
  'use strict';

  const main = document.getElementById('MainContent');

  if (!main) return;

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const processed = new WeakSet();

  const excludedSelector = [
    'header',
    'footer',
    '.announcement-bar',
    '.cart-drawer',
    '.cart-notification',
    '.drawer',
    '.modal',
    '.product-form',
    '.shopify-payment-button',
    '[class*="checkout"]',
    '[class*="controls"]',
    '[class*="pagination"]',
    '[hidden]',
    '[aria-hidden="true"]',
    '.no-scroll-reveal'
  ].join(', ');

  const observer =
    !reducedMotion && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              entry.target.classList.add('sr-visible');
              observer.unobserve(entry.target);
            });
          },
          {
            threshold: 0.08,
            rootMargin: '0px 0px -10% 0px'
          }
        )
      : null;

  function isUsable(element) {
    if (!(element instanceof HTMLElement)) return false;

    if (
      element.matches(excludedSelector) ||
      element.closest('.no-scroll-reveal')
    ) {
      return false;
    }

    const styles = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      rect.width > 40 &&
      rect.height > 40
    );
  }

  function removeDecorativeElements(elements) {
    const filtered = elements.filter(function (element) {
      const identifier =
        String(element.className || '') + ' ' + String(element.id || '');

      return !/(background|overlay|controls?|pagination|visually-hidden)/i.test(
        identifier
      );
    });

    return filtered.length ? filtered : elements;
  }

  function findTargets(section) {
    const productItems = Array.from(
      section.querySelectorAll(
        [
          '.product-grid__item',
          '.collection-list__item',
          '.resource-list__item',
          '[class*="gallery-grid"] > *',
          '[class*="mosaic"] > *'
        ].join(', ')
      )
    ).filter(isUsable);

    if (productItems.length > 1) {
      return productItems;
    }

    const themeBlocks = Array.from(
      section.querySelectorAll('.shopify-block')
    ).filter(function (element) {
      const parentBlock = element.parentElement
        ? element.parentElement.closest('.shopify-block')
        : null;

      return !parentBlock && isUsable(element);
    });

    if (themeBlocks.length > 1) {
      return themeBlocks;
    }

    let currentElement = section;

    for (let depth = 0; depth < 7; depth += 1) {
      let children = Array.from(currentElement.children).filter(isUsable);
      children = removeDecorativeElements(children);

      if (children.length > 1) {
        return children;
      }

      if (children.length === 1) {
        currentElement = children[0];
        continue;
      }

      break;
    }

    return isUsable(currentElement) ? [currentElement] : [];
  }

  function prepareElement(element, index) {
    if (processed.has(element)) return;

    processed.add(element);

    const delay = Math.min(index, 6) * 90;

    element.style.setProperty('--sr-delay', delay + 'ms');
    element.classList.add('sr-reveal');

    if (observer) {
      observer.observe(element);
    } else {
      element.classList.add('sr-visible');
    }
  }

  function initialize(scope) {
    const sections = [];

    if (
      scope instanceof Element &&
      scope.matches('[id^="shopify-section-"]')
    ) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections.push(
        ...scope.querySelectorAll(
          '#MainContent [id^="shopify-section-"], [id^="shopify-section-"]'
        )
      );
    }

    sections.forEach(function (section) {
      if (section.closest('header, footer')) return;

      const targets = findTargets(section);

      targets.forEach(function (element, index) {
        prepareElement(element, index);
      });
    });
  }

  initialize(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  const mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        const section =
          node.matches('[id^="shopify-section-"]')
            ? node
            : node.closest('[id^="shopify-section-"]');

        initialize(section || node);
      });
    });
  });

  mutationObserver.observe(main, {
    childList: true,
    subtree: true
  });
})();